var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-manage-filters-wrapper" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            title: "Управление фильтрами",
          },
          model: {
            value: _vm.listModal,
            callback: function ($$v) {
              _vm.listModal = $$v
            },
            expression: "listModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "m-manage-filters" },
            [
              _c(
                "div",
                { staticClass: "m-manage-filters-list-actions" },
                [
                  _vm.costructor
                    ? _c("c-button", {
                        staticClass:
                          "m-manage-filters-list-action m-manage-filters-list-action-constructor",
                        attrs: {
                          label: "Конструктор фильтров",
                          size: "small",
                          responsive: true,
                          icon: { icon: "constructor" },
                        },
                        on: { click: _vm.openConstructorModal },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "m-manage-filters-list-notice",
                  class: {
                    "m-manage-filters-list-notice_hidden": !_vm.emptyError,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "m-manage-filters-list-notice-icon" },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 14 14",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: {
                              cx: "7",
                              cy: "7",
                              r: "6.5",
                              fill: "white",
                              stroke: "#FF238D",
                            },
                          }),
                          _c("circle", {
                            attrs: {
                              cx: "7",
                              cy: "10",
                              r: "1",
                              fill: "#FF238D",
                            },
                          }),
                          _c("rect", {
                            attrs: {
                              x: "6",
                              y: "3",
                              width: "2",
                              height: "5",
                              rx: "1",
                              fill: "#FF238D",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "m-manage-filtes-list-notice-text" },
                    [
                      _vm._v(
                        " Для сохранения текущих фильтров нужно выбрать хотя бы один параметр "
                      ),
                    ]
                  ),
                ]
              ),
              _c("c-list", {
                staticClass: "m-manage-filters-content-list",
                attrs: { items: _vm.setsUserFilters },
                on: {
                  clickAction: _vm.clickFilterAction,
                  clickTitle: _vm.applyFilter,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            title: "Управление фильтрами",
          },
          model: {
            value: _vm.saveModal,
            callback: function ($$v) {
              _vm.saveModal = $$v
            },
            expression: "saveModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "m-manage-filters" },
            [
              _c("c-input-old", {
                attrs: {
                  placeholder: "Введите название для параметров фильтра",
                },
                model: {
                  value: _vm.newFilter,
                  callback: function ($$v) {
                    _vm.newFilter = $$v
                  },
                  expression: "newFilter",
                },
              }),
              _c(
                "div",
                { staticClass: "m-manage-filters-actions" },
                [
                  _c("c-button", {
                    staticClass: "m-manage-filters-action",
                    attrs: { label: "Отменить" },
                    on: {
                      click: function ($event) {
                        return _vm.openModal("list")
                      },
                    },
                  }),
                  _c("c-button", {
                    staticClass: "m-manage-filters-action",
                    attrs: {
                      label: "Сохранить",
                      color: "primary",
                      disabled: _vm.newFilter === "",
                    },
                    on: { click: _vm.saveFilter },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            title: "Управление фильтрами",
          },
          model: {
            value: _vm.shareModal,
            callback: function ($$v) {
              _vm.shareModal = $$v
            },
            expression: "shareModal",
          },
        },
        [
          _c("div", { staticClass: "m-manage-filters" }, [
            _c("div", { staticClass: "m-manage-filters-content" }, [
              _vm._v(
                " Выберите сотрудников, с которыми хотите поделиться фильтром "
              ),
              _c("strong", [
                _vm._v(_vm._s(_vm.selectedItem && _vm.selectedItem.title)),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "m-manage-filters__share" },
              [
                _c("c-input-old", {
                  staticClass: "m-manage-filters__share-select",
                  attrs: {
                    placeholder: "Сотрудники",
                    type: "select",
                    multiple: true,
                    items: _vm.users,
                    searchable: true,
                  },
                  model: {
                    value: _vm.selectedUsers,
                    callback: function ($$v) {
                      _vm.selectedUsers = $$v
                    },
                    expression: "selectedUsers",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "m-manage-filters__share-switchers" },
                  _vm._l(_vm.users, function (user) {
                    return _c("c-switcher", {
                      key: user.value,
                      staticClass: "m-manage-filters__share-switcher",
                      attrs: {
                        label: user.label,
                        image: user.avatar,
                        type: "checkbox",
                      },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "m-manage-filters-actions" },
              [
                _c("c-button", {
                  staticClass: "m-manage-filters-action",
                  attrs: { label: "Отменить" },
                  on: {
                    click: function ($event) {
                      _vm.content = "list"
                    },
                  },
                }),
                _c("c-button", {
                  staticClass: "m-manage-filters-action",
                  attrs: { label: "Поделиться", color: "primary" },
                  on: { click: _vm.shareItem },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }